<template>
  <div>
    <div class="upgrade-tag text-mini bold d-flex align-items-center pointer" @click="onClick">
      <i class="star-icon mr-1"></i>
      <span>UPGRADE</span>
    </div>
    <paywall-modal :feature-type="FEATURE_TYPE.BOOLEAN" v-model="showPaywallModal">
      <div slot="heading">
        <slot name="heading"></slot>
      </div>
      <div slot="content">
        <slot name="content"></slot>
      </div>
    </paywall-modal>
  </div>
</template>

<script>
import PaywallModal from '@/components/paywalls/PaywallModal.vue'
import { ADMIN_PANEL_TAB_ID } from '@/constants/adminPanel'
import { FEATURE_TYPE } from '@/constants/featureFlags'
import { USER_TYPE } from '@/constants/user'
import handleClickNavigation from '@/utils/handleClickNavigation'
import { getAdminPageRouteConfig } from '@/utils/navigationConfigs'

/**
 * This give a tag that indicating that the feature is a premium feature
 * and user needs to upgrade to higher plans to access it.
 */
export default {
  name: 'UpgradeTag',
  props: ['orgId'],
  components: {
    PaywallModal
  },
  data() {
    return {
      FEATURE_TYPE,
      showPaywallModal: false
    }
  },
  computed: {
    rootTeamId() {
      return this.$store.getters.rootTeamByOrgId(this.orgId).id
    },
    userType() {
      const userId = this.$store.getters.user.id
      const orgMembers = this.$store.getters.orgMemberships(this.orgId)
      const user = orgMembers?.find(x => x.userId === userId)
      return user?.type
    }
  },
  methods: {
    onClick(event) {
      if (this.userType === USER_TYPE.OWNER) {
        const plansPageLocation = getAdminPageRouteConfig({
          orgId: this.orgId,
          subOrgId: this.rootTeamId,
          query: {
            section: ADMIN_PANEL_TAB_ID.PLANS_TAB_ID
          }
        })
        handleClickNavigation.call(this, event, plansPageLocation)
        this.$emit('click', event)
      } else {
        this.showPaywallModal = true
      }
    }
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

.upgrade-tag {
  background-color: $activeQuaternary;
  border-radius: 50px;
  color: $activeSecondary;
  padding: 2px 10px 2px 6px;
  border: 1px solid $activeSecondary;
}

.star-icon {
  @include dimension(12px, 12px);
}
</style>
